import { render, staticRenderFns } from "./OperationDetailsForm.vue?vue&type=template&id=85fe9714&scoped=true"
import script from "./OperationDetailsForm.vue?vue&type=script&lang=js"
export * from "./OperationDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./OperationDetailsForm.vue?vue&type=style&index=0&id=85fe9714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe9714",
  null
  
)

export default component.exports